import dateWrapper from "./_dateWrapper";

export default function ({ input, inputFormat = "" }) {
  const dateLib = dateWrapper(input, inputFormat);
  return dateLib;
}
